import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import Icon from "../../assets/img/Logo.png";
import IosShareIcon from "@mui/icons-material/IosShare";
import { useTranslation } from "react-i18next";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PwaModal({ showPwa, setShowPwa }) {
  const { t } = useTranslation();
  const handleClose = () => {
    setShowPwa(false);
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={showPwa}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <Box
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            mb: 6,
            p: "24px",
          }}
        >
          <Stack
            spacing={1}
            justifyContent={"center"}
            alignItems={"center"}
            display={"flex"}
          >
            <Box
              sx={{
                borderRadius: "16px",
                width: "128px",
                marginBottom: "24px !important",
              }}
            >
              <div className="img" style={{ width: "128px" }}>
                <img
                  src={Icon}
                  loading="lazy"
                  alt="Postex"
                  style={{ width: "128px" }}
                />
              </div>
            </Box>
            <Typography
              variant="h6"
              component="h2"
              textAlign={"center"}
              sx={{ fontWeight: "600" }}
            >
              {t("login.t16")}
            </Typography>
            <Typography
              textAlign={"center"}
              sx={{ mt: 2, mb: 3, color: "gray", fontSize: "16px" }}
              component="h2"
            >
              {t("login.t15")}
            </Typography>
            <Stack
              spacing={3}
              justifyContent={"space-between"}
              alignItems={"flex-end"}
              display={"flex"}
              flexDirection={"row"}
              width={"100%"}
              textAlign={"left"}
              whiteSpace={"nowrap"}
              mt={"20px !important"}
            >
              <Typography
                sx={{ fontSize: "18px", color: "black", m: "0px !important" }}
              >
                {t("login.t14")}
              </Typography>
              <IosShareIcon
                sx={{ fontSize: "30px", color: "#01A0E1", pb: "5px" }}
              />
            </Stack>
            <Stack
              spacing={3}
              justifyContent={"space-between"}
              alignItems={"flex-end"}
              display={"flex"}
              flexDirection={"row"}
              width={"100%"}
              textAlign={"left"}
              whiteSpace={"nowrap"}
            >
              <Typography
                sx={{ fontSize: "18px", color: "black", m: "0px !important" }}
              >
                {t("login.t13")}
              </Typography>
              <AddBoxOutlinedIcon
                sx={{
                  fontSize: "30px",
                  color: "#01A0E1",
                  pb: "5px",
                }}
              />
            </Stack>
            <Stack
              spacing={3}
              justifyContent={"space-between"}
              alignItems={"flex-end"}
              display={"flex"}
              flexDirection={"row"}
              width={"100%"}
              textAlign={"left"}
              whiteSpace={"nowrap"}
            >
              <Typography
                sx={{ fontSize: "18px", color: "black", m: "0px !important" }}
              >
                {t("login.t12")}
              </Typography>
              <span
                style={{
                  fontSize: "18px",
                  color: "white",
                  color: "#01A0E1",
                  fontWeight: "600",
                }}
              >
                Add
              </span>
            </Stack>
            <div
              className="_btnGroup_yellow justify-content-end"
              style={{ width: "100%", marginTop: "24px" }}
            >
              <button
                className="btnFill"
                style={{
                  width: "100%",
                  justifyContent: "center",
                  margin: "0px",
                }}
                onClick={handleClose}
              >
                {t("login.t11")}
              </button>
            </div>
          </Stack>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
